import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/modal';
import React from 'react';
import classes from './styles.module.scss';
import clsx from 'clsx';

export default function SKModal({
  isOpen,
  onClose,
  title,
  footer,
  children,
  center = false,
  videoModal = false,
  ...rest
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className={clsx(classes.modal,videoModal && classes.videoModal)} {...rest}>
      <ModalOverlay className={classes.ModalOverlay} />
      <ModalContent className={clsx(classes.ModalContent,videoModal && classes.videoModal)}>
        {title && (
          <ModalHeader className={clsx(classes.ModalHeader,videoModal && classes.videoModal)}>{title}</ModalHeader>
        )}
        <ModalCloseButton className={clsx(classes.ModalCloseButton,videoModal && classes.videoModal)} />
        <ModalBody className={clsx(classes.ModalBody,center && classes.centerContent,videoModal && classes.videoModal)}>{children}</ModalBody>

        {footer && (
          <ModalFooter className={classes.ModalFooter}>{footer}</ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
}
